import type { ReactNode } from 'react'

type PassthroughShellProps = {
  children: ReactNode
}

export const levelPlayRegexes = [
  /\/jornadas\/[^/]+\/niveis\/[^/]+\/iniciar$/,
  /\/niveis\/[^/]+\/iniciar$/,
  /\/quizzes\/[^/]+\/iniciar$/,
  /\/quests\/[^/]+$/
]

export function isLevelPlayRoute(pathname: string) {
  return levelPlayRegexes.some(regex => regex.test(pathname))
}

export function PassthroughShell({ children }: PassthroughShellProps) {
  return (
    <div className="flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden">
      {children}
    </div>
  )
}
